export class FactureDetailNormalize {
    id: string = null;
    tra_id: string;
    cpt_id: string;
    clr_id: string;
    art_id: string;
    frais_privatifs_lot_id: string;
    frais_privatifs_trs_id: string;
    frais_privatifs: string;
    code_tva: string;
    montant_ttc: number;
    montant_ht: number;
    tva_taux: number;
    part_occupant: string;
    part_deductible: string;
    libelle_detail: string;
    remise_montant: number = null;
    remise_type: string = null;
    prix_u: number  = null;
    quantite: number  = null;
    classe_comptable: number = null;
    title: number = null;

    constructor(init?: Partial<FactureDetailNormalize>) {
        for (let prop in init) {
            this[prop] = init[prop];
        }
    }
}
